module.exports = __webpack_public_path__ + "static/bot-1ff571e9c6cee812a32bd20d1b787a44.png";